import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchEPolicies } from "./ethicspolicyAPI";

export interface EPolicyState {
  epolicies: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: EPolicyState = {
  epolicies: [],
  status: "idle",
};

export const GetEthicsPolicies = createAsyncThunk(
  "epolicy/fetchEPolicies",
  async (data:any) => {
    const response = await fetchEPolicies(data);
    return response;
  }
);

export const epolicySlice = createSlice({
  name: "epolicy",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetEthicsPolicies.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetEthicsPolicies.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetEthicsPolicies.fulfilled, (state, action) => {
        state.status = "success";
        state.epolicies = action.payload;
      });
  },
});

export const {} = epolicySlice.actions;

export const selectEPolicies = (state: RootState) => {
  return state.epolicy.epolicies;
};

export default epolicySlice.reducer;
